/* eslint-disable */
import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';
import gridHelper from '@bingads-webui-static-legacy/shared/view/gridHelper';
import * as filterMetadataToLegacy from '@bingads-webui/filter-commons';
export default {
  getFiltersIncludeWaterfall: function (grid) {
    if (grid && (grid.filterService || grid.pgridPlugins && grid.pgridPlugins.filterService)) {
      var filterServiceFilters = (grid.filterService || grid.pgridPlugins.filterService).getCombinedFilter();
      return {
        FilterExpressions: filterMetadataToLegacy.toLegacyFilter(filterServiceFilters)
      };
    } else {
      return grid.getFilters(true);
    }
  },
  getIdFilter: function (grid, entityType) {
    if (grid) {
      var ids = gridHelper.getSelectedRowIds(grid);
      if (entityType === 'Keyword' && !grid.gridView) {
        ids = _.map(ids, function (value) {
          return value.substring(0, value.indexOf('_'));
        });
      }
      return {
        FilterExpressions: [{
          SelectedColumn: entityType + 'Id',
          SelectedOperator: 'Equal',
          Values: ids
        }]
      };
    }
  },
  getIdFilterNoEntityType: function (grid) {
    if (grid) {
      var ids = gridHelper.getSelectedRowIds(grid);
      ids = _.map(ids, function (id) {
        return Number(id);
      });
      return {
        FilterExpressions: [{
          SelectedColumn: 'Id',
          SelectedOperator: 'Equal',
          Values: ids
        }]
      };
    }
  },
  getProductGroupIdFilter: function (grid) {
    if (grid) {
      var isOnAdGroupLevel = pageContext.CurrentAdGroup != null;
      var rows = gridHelper.getSelectedRows(grid);
      if (isOnAdGroupLevel) {
        var completeIds = _.map(rows, function (row) {
          return row.Id;
        });
        var groupSize = 200;
        var idGroups = _.reduce(completeIds, function (result, id) {
          var lastGroup = result[result.length - 1];
          if (lastGroup == null || lastGroup.length === groupSize) {
            result.push([id]);
          } else {
            lastGroup.push(id);
          }
          return result;
        }, []);
        var compositeIds = _.map(idGroups, function (group) {
          return group.join(',');
        });
        var filterExpressions = [{
          SelectedColumn: 'IdString',
          SelectedOperator: 'eq',
          Values: compositeIds
        }];
        return {
          FilterExpressions: filterExpressions
        };
      } else {
        var hasInvalidParam = false;
        var compositeIds = _.map(rows, function (row) {
          var campaignId = pageContext.CurrentCampaign && pageContext.CurrentCampaign.Id != null ? pageContext.CurrentCampaign.Id : row.CampaignId;
          var adGroupId = pageContext.CurrentAdGroup && pageContext.CurrentAdGroup.Id != null ? pageContext.CurrentAdGroup.Id : row.AdGroupId;
          if (campaignId == null || adGroupId == null) {
            hasInvalidParam = true;
          }
          return 'CampaignId=' + campaignId + ',AdGroupId=' + adGroupId + ',ProductGroupId=' + row.Id;
        });
        var filterExpressions = [{
          SelectedColumn: 'IdString',
          SelectedOperator: 'eq',
          Values: !hasInvalidParam ? compositeIds : []
        }];
        return {
          FilterExpressions: filterExpressions
        };
      }
    }
  },
  getPerformanceTargetIdFilter: function (grid) {
    if (grid) {
      var ids = gridHelper.getSelectedRowIds(grid);
      ids = _.map(ids, function (value) {
        return Number(value);
      });
      return {
        FilterExpressions: [{
          SelectedColumn: 'Id',
          SelectedOperator: 'Equal',
          Values: ids
        }]
      };
    }
  },
  getAdGroupIdFilterExcludingContentOnly: function (grid) {
    if (grid) {
      var rows = gridHelper.getSelectedRows(grid);
      var ids = [];
      _.each(rows, function (key, value) {
        if (!_.contains(['2', 'Content'], key.Medium)) {
          ids[ids.length] = key.Id;
        }
      });
      return {
        FilterExpressions: [{
          SelectedColumn: 'AdGroupId',
          SelectedOperator: 'Equal',
          Values: ids
        }]
      };
    }
  },
  getCampaignIdFilter: function (grid) {
    if (grid) {
      var rows = gridHelper.getSelectedRows(grid);
      var ids = _.map(rows, function (r) {
        return r.Id;
      });
      return {
        FilterExpressions: [{
          SelectedColumn: 'CampaignId',
          SelectedOperator: 'Equal',
          Values: ids
        }]
      };
    }
  },
  getAudienceIdFilter: function (grid, shouldExclude) {
    if (grid) {
      var ids = [];
      if (!shouldExclude) {
        ids = gridHelper.getSelectedRowIds(grid);
      } else {
        var rows = gridHelper.getSelectedRows(grid);
        _.each(rows, function (row) {
          if (row.Status !== 'Excluded') {
            ids.push(row.Id);
          }
        });
      }
      return {
        FilterExpressions: [{
          SelectedColumn: 'AudienceAssociationId',
          SelectedOperator: 'Equal',
          Values: ids
        }]
      };
    }
  }
};

